import React, { useState } from 'react'
import { useServiceContext } from '../../root'

interface SelectAllContentProps {
  onSelectAllClick?: () => void
  selectedItems: any[]
  total: number
  allItemsSelectedText?: string
  selectAllItemsText?: string
  textParams?: Record<string, any>
  isWorkflowCancelled?: boolean
  onClearSelectionClick?: () => void
}

const SelectAllContent: React.FC<SelectAllContentProps> = ({
  onSelectAllClick,
  selectedItems,
  total,
  allItemsSelectedText,
  selectAllItemsText,
  textParams,
  isWorkflowCancelled,
  onClearSelectionClick = () => {}
}) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const [isSelectAllItems, setIsSelectAllItems] = useState(false)

  const handleClickOnSelectAll = () => {
    setIsSelectAllItems(true)
    if (typeof onSelectAllClick === 'function') {
      onSelectAllClick()
    }
  }

  return (
    <div className="clearfix">
      {Array.isArray(selectedItems) && selectedItems.length !== total && (
        <div id="toast-container" style={{ zIndex: 0 }} className="inline select-all">
          <div className="toast toast-info">
            <div>
              <div className="toast-message">
                {!isSelectAllItems ? (
                  <>
                    <span>
                      {translate(
                        'MULTISELECT_ALL_N_ITEMS_SELECTED',
                        textParams || { number: selectedItems.length }
                      )}{' '}
                    </span>
                    {!isWorkflowCancelled && (
                      <a onClick={handleClickOnSelectAll}>
                        {translate(
                          selectAllItemsText || 'MULTISELECT_SELECT_ALL_IN_SECTION',
                          textParams || { allItems: total }
                        )}
                      </a>
                    )}
                  </>
                ) : (
                  <>
                    <span>
                      {translate(
                        allItemsSelectedText || 'MULTISELECT_ALL_N_ITEMS_IN_IN_SECTION_SELECTED',
                        textParams || { allItems: total }
                      )}{' '}
                    </span>
                    <a onClick={() => onClearSelectionClick()}>{translate('MULTISELECT_CLEAR_SELECTION')}</a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SelectAllContent
